var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('iframe',{staticClass:"iframe_dashboard",attrs:{"title":"Report Section","src":"https://app.powerbi.com/view?r=eyJrIjoiOTA4ZmY4MmUtNjE2YS00ZTM4LTk3YTItNjhjZjNkODE0MWQ5IiwidCI6IjY1NzlmZDU2LTM1NTUtNDkwOS1iMTJmLTk4YmNjMWZmN2NmMCIsImMiOjR9","frameborder":"0","allowFullScreen":"true"}})])
}]

export { render, staticRenderFns }